import { render, staticRenderFns } from "./CurrenciesSelect.vue?vue&type=template&id=562b3774&scoped=true&"
import script from "./CurrenciesSelect.vue?vue&type=script&lang=js&"
export * from "./CurrenciesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562b3774",
  null
  
)

export default component.exports